import React from 'react';
import Header from './components/Header';
import './style.css';
import GraficoSentimento from './components/GraficoSentimento/index.js'
import OverlayLoader from 'react-overlay-loading/lib/OverlayLoader'
import ReactGA from 'react-ga';

class Home extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false,
            dados: [],
            cidades: []
        };
    }

    componentWillMount() {
        ReactGA.modalview('Home');
        fetch("/politicos-total-processados3.min.json")
            .then(res => res.json())
            .then(
                (result) => {
                    const cidades = result.map(cidade => cidade.cidade).sort();
                    const cidadeSelecionada = result.filter(cidade => cidade.cidade === cidades[0])[0];

                    this.setState({
                        isLoaded: true,
                        dados: result,
                        cidades: cidades,
                        cidadeSelecionada: cidadeSelecionada
                    });
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    ReactGA.exception({
                        description: 'Erro pegando o json dos politicos',
                        fatal: true
                    });

                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            );
    }

    trocaCidade(event) {
        ReactGA.event({
            category: 'Cidades',
            action: 'Trocou para a cidade',
            label: event.target.value
        });

        const cidadeSelecionada = this.state.dados.filter(cidade => cidade.cidade === event.target.value)[0];
        this.setState({cidadeSelecionada: cidadeSelecionada});
    }

    render () {
        let dadosPoliticos = null;
        let cidade = null;
        if (this.state.isLoaded) {
            dadosPoliticos = this.state.cidadeSelecionada.politicos;
            cidade = this.state.cidadeSelecionada.cidade;
        }

        return (
            <OverlayLoader
                color={'purple'} // default is white
                loader="PacmanLoader" // Check http://www.davidhu.io/react-spinners/
                text="Loading... Please wait!"
                active={true}
                backgroundColor={'#263238'} // default is black
                opacity=".8" // default is .9
                >
                <Header cidades={this.state.cidades}
                        selecionada={this.state.cidadeSelecionada}
                        isLoaded={this.state.isLoaded}
                        onChangeCidade={event => this.trocaCidade(event)}/>
                <main role="main" style={{backgroundColor: "#263238"}}>
                    <div className="section-grafico">
                        <div className="container" id="container-grafico">
                            <div className="row">
                                <div className="col-md-12">
                                    <GraficoSentimento dados={dadosPoliticos}
                                                       cidade={cidade}
                                                       error={this.state.error} isLoaded={this.state.isLoaded}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br/><br/>
                </main>
            </OverlayLoader>
        )
    }
}

export default Home;


// WEBPACK FOOTER //
// ./src/scenes/Home/index.js